import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description:
    'REST catch-up found an assistant message that was not already in the open thread (the live socket did not deliver it)',
  name: 'agent_message_missed',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The id of the assistant message that was missing from the open thread',
      name: 'message_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The id of the workspace agent session the missed message belongs to',
      name: 'session_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
